module.exports = __webpack_public_path__ + "img/playerIcon.41c55873.svg";